import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/not-found.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/dictionary/dictionary.provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderButtons"] */ "/app/src/components/header-buttons/header-buttons.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/mobile-menu/overlay-mobile-menu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Overlays"] */ "/app/src/components/overlays/overlays.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderTicketsBalance"] */ "/app/src/components/ticket-balance/header-tickets-balance.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/Block/effect-dots.svg");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/Block/effect-droplets.svg");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/Block/effect-stripes.svg");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/Block/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/Footer/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/Button/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/Body/styles.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ui/Header/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ui/Interactive/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/LoadingContent/styles.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["AppKit"] */ "/app/src/context/app-kit-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BrandProvider"] */ "/app/src/context/brand.context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/lib/analytics/GTMProvider.tsx");
